import type { NavEntry } from './nav-registry'

const MODULE_PATHS: readonly [string, string][] = [
  ['/settings/search', 'search'], ['/search', 'search'], ['/s/', 'search'],
  ['/work-orders', 'maintenance'], ['/maintenance', 'maintenance'],
  ['/downtime', 'equipment'], ['/equipment', 'equipment'],
  ['/notes', 'notes'], ['/forms', 'forms'], ['/documents', 'documents'],
  ['/quality/changes','change_control'],['/settings/change-control','change_control'],
  // /inspections: OWNED by audits (D22 gating — the scoring engine lives
  // there) but GROUPED under Maintenance in nav-registry (E-M-01: the owner
  // wants equipment inspections beside equipment/WOs). Module ≠ nav group;
  // this pairing is deliberate, not drift.
  ['/checks', 'checks'], ['/cars', 'cars'], ['/audits', 'audits'], ['/inspections', 'audits'],
  ['/assignment', 'assignment'], ['/automation', 'automation'], ['/parts', 'parts'], ['/vendors', 'vendors'],
  ['/safety', 'incidents'], ['/help-requests', 'incidents'], ['/training', 'training'], ['/chat', 'chat-comments'], ['/inbox', 'chat-comments'],
  ['/reports', 'reports'], ['/ai', 'ai'], ['/integrations', 'integrations'],
  ['/quality/nonconformances', 'ncr'],
  ['/quality/deviations', 'deviations_oos'], ['/quality/oos', 'deviations_oos'],
  ['/quality/lots', 'lot_genealogy'],
  ['/quality/fmea', 'risk_fmea'], ['/quality/risks', 'risk_fmea'],
  ['/quality/esign', 'regulated_esign'],
  ['/suppliers/quality', 'supplier_quality'],
  ['/people/hr-records', 'hr_records'],
]

export function moduleForWebPath(pathname: string): string | undefined {
  return MODULE_PATHS.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`) || (prefix.endsWith('/') && pathname.startsWith(prefix)))?.[1]
}

/**
 * H-11: the route-level permission gate derives from the SAME nav registry
 * the sidebar renders from — no second hand-maintained map. The nav entry
 * whose `path` is the longest prefix of the pathname (exact, or followed by
 * '/') decides; paths with no nav entry (dashboard '/', account, scan,
 * search) are never blocked. Empty and '/' prefixes are ignored so a root
 * entry can never accidentally gate everything.
 */
export function permissionForWebPath(
  pathname: string,
  navEntries: readonly NavEntry[],
): string | undefined {
  let best: NavEntry | undefined
  for (const entry of navEntries) {
    const prefix = entry.path
    if (!prefix || prefix === '/') continue
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      if (!best || prefix.length > best.path.length) best = entry
    }
  }
  return best?.permission
}
